// extracted by mini-css-extract-plugin
module.exports = {"cell":"TableBody_cell__1COBc"};